import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';

import { matchMedia } from './utility';

/* eslint-disable import/no-unresolved */
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/autoplay';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/effect-fade';

class Carousel {
  constructor(swiperContainer, parameters = {}) {
    this.container = swiperContainer;
    this.parameters = parameters;
    this.instance = null;
  }

  active() {
    // eslint-disable-next-line no-undef
    this.instance = new Swiper(this.container, this.parameters);
  }

  inactive() {
    if (this.instance !== null) {
      this.instance.destroy();
      this.instance = null;
    }
  }
}

const sliderMV = () => {
  const containerElements = document.querySelectorAll('.js-mvCopy');
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };
  containerElements.forEach((element) => {
    carouselInstance.push(
      new Carousel(element, {
        modules: [Autoplay, EffectFade],
        loop: false,
        slidesPerView: 'auto',
        speed: 0,
        followFinger: false,
        effect: 'fade',
        autoplay: {
          delay: 7500,
          disableOnInteraction: false,
        },
        on: {
          beforeInit() {
            const firstSlideBlock = element.querySelector('.js-typeWriter01');
            if (firstSlideBlock === null) return;
            const element01 = firstSlideBlock.querySelector('.js-typeWriter01-01');
            const element02 = firstSlideBlock.querySelector('.js-typeWriter01-02');
            setTimeout(() => {
              const item0101words = [
                '<span class="_colorPrimary">エ</span>',
                '<span class="_colorPrimary">ン</span>',
                '<span class="_colorPrimary">タ</span>',
                '<span class="_colorPrimary">ー</span>',
                '<span class="_colorPrimary">プ</span>',
                '<span class="_colorPrimary">ラ</span>',
                '<span class="_colorPrimary">イ</span>',
                '<span class="_colorPrimary _lastText">ズ</span>',
                '企',
                '業',
                'の',
              ];
              element01.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
              item0101words.forEach((word, index) => {
                setTimeout(() => {
                  element01.firstElementChild.innerHTML += word;
                }, 100 * index);
              });
            }, 500);
            setTimeout(() => {
              const item0102words = ['採', '用', '実', '績', '多', '数'];
              element02.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
              item0102words.forEach((word, index) => {
                setTimeout(() => {
                  element02.firstElementChild.innerHTML += word;
                }, 100 * index);
              });
            }, 2500);
          },
          slideChange() {
            const activeSlide = element.querySelector('.swiper-slide-active');
            if (activeSlide === null) return;
            const item01Blocks = element.querySelectorAll('.js-typeWriter01');
            const item02Blocks = element.querySelectorAll('.js-typeWriter02');
            const item03Blocks = element.querySelectorAll('.js-typeWriter03');
            const item04Blocks = element.querySelectorAll('.js-typeWriter04');
            if (activeSlide.classList.contains('js-typeWriter04')) {
              item04Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriter04-01');
                const element02 = block.querySelector('.js-typeWriter04-02');
                element01.innerHTML = '';
                element02.innerHTML = '';
              });
              item01Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriter01-01');
                const element02 = block.querySelector('.js-typeWriter01-02');
                setTimeout(() => {
                  const item0101words = [
                    '<span class="_colorPrimary">エ</span>',
                    '<span class="_colorPrimary">ン</span>',
                    '<span class="_colorPrimary">タ</span>',
                    '<span class="_colorPrimary">ー</span>',
                    '<span class="_colorPrimary">プ</span>',
                    '<span class="_colorPrimary">ラ</span>',
                    '<span class="_colorPrimary">イ</span>',
                    '<span class="_colorPrimary _lastText">ズ</span>',
                    '企',
                    '業',
                    'の',
                  ];
                  element01.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                  item0101words.forEach((word, index) => {
                    setTimeout(() => {
                      element01.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 0);
                setTimeout(() => {
                  const item0102words = ['採', '用', '実', '績', '多', '数'];
                  element02.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                  item0102words.forEach((word, index) => {
                    setTimeout(() => {
                      element02.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 2500);
              });
            } else if (activeSlide.classList.contains('js-typeWriter01')) {
              item01Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriter01-01');
                const element02 = block.querySelector('.js-typeWriter01-02');
                element01.innerHTML = '';
                element02.innerHTML = '';
              });
              item02Blocks?.forEach((block) => {
                const element0201 = block.querySelector('.js-typeWriter02-01');
                const element0202 = block.querySelector('.js-typeWriter02-02');
                const element0203 = block.querySelector('.js-typeWriter02-03');

                if (matchMedia('md').matches) {
                  setTimeout(() => {
                    const item0201words = [
                      '支',
                      '払',
                      '関',
                      '連',
                      '書',
                      '類',
                      'ソ',
                      'リ',
                      'ュ',
                      'ー',
                      'シ',
                      'ョ',
                      'ン',
                    ];
                    element0201.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0201words.forEach((word, index) => {
                      setTimeout(() => {
                        element0201.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0202words = [
                      '売',
                      '上',
                      '額',
                      '<span class="_colorPrimary">シ</span>',
                      '<span class="_colorPrimary">ェ</span>',
                      '<span class="_colorPrimary">ア</span>',
                      '<span class="_colorPrimary">N</span>',
                      '<span class="_colorPrimary">o</span>',
                      '<span class="_colorPrimary">.</span>',
                      '<span class="_colorPrimary _lastText">1</span>',
                    ];
                    element0202.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                    item0202words.forEach((word, index) => {
                      setTimeout(() => {
                        element0202.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                } else {
                  setTimeout(() => {
                    const item0201words = ['支', '払', '関', '連', '書', '類'];
                    element0201.innerHTML = '<span class="_bgWhite _typeWriter00" aria-hidden="true"></span>';
                    item0201words.forEach((word, index) => {
                      setTimeout(() => {
                        element0201.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0202words = ['ソ', 'リ', 'ュ', 'ー', 'シ', 'ョ', 'ン'];
                    element0202.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0202words.forEach((word, index) => {
                      setTimeout(() => {
                        element0202.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 1000);
                  setTimeout(() => {
                    const item0203words = [
                      '売',
                      '上',
                      '額',
                      '<span class="_colorPrimary">シ</span>',
                      '<span class="_colorPrimary">ェ</span>',
                      '<span class="_colorPrimary">ア</span>',
                      '<span class="_colorPrimary">N</span>',
                      '<span class="_colorPrimary">o</span>',
                      '<span class="_colorPrimary">.</span>',
                      '<span class="_colorPrimary _lastText">1</span>',
                    ];
                    element0203.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                    item0203words.forEach((word, index) => {
                      setTimeout(() => {
                        element0203.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2800);
                }
              });
            } else if (activeSlide.classList.contains('js-typeWriter02')) {
              item02Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriter02-01');
                const element02 = block.querySelector('.js-typeWriter02-02');
                const element03 = block.querySelector('.js-typeWriter02-03');
                element01.innerHTML = '';
                element02.innerHTML = '';
                element03.innerHTML = '';
              });
              item03Blocks?.forEach((block) => {
                const element0301 = block.querySelector('.js-typeWriter03-01');
                const element0302 = block.querySelector('.js-typeWriter03-02');
                const element0303 = block.querySelector('.js-typeWriter03-03');
                if (matchMedia('md').matches) {
                  setTimeout(() => {
                    const item0301words = ['紙', 'の', '請', '求', '書', '・', 'P', 'D', 'F', '請', '求', '書', '・'];
                    element0301.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0301words.forEach((word, index) => {
                      setTimeout(() => {
                        element0301.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0302words = [
                      'デ',
                      'ジ',
                      'タ',
                      'ル',
                      'イ',
                      'ン',
                      'ボ',
                      'イ',
                      'ス',
                      'も',
                      '<span class="_colorPrimary">一</span>',
                      '<span class="_colorPrimary">元</span>',
                      '<span class="_colorPrimary">管</span>',
                      '<span class="_colorPrimary _lastText">理</span>',
                    ];
                    element0302.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                    item0302words.forEach((word, index) => {
                      setTimeout(() => {
                        element0302.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                } else {
                  setTimeout(() => {
                    const item0301words = [
                      '紙',
                      'の',
                      '請',
                      '求',
                      '書',
                      '<span class="_thin">・</span>',
                      'P',
                      'D',
                      'F',
                      '請',
                      '求',
                      '書',
                      '<span class="_thin">・</span>',
                    ];
                    element0301.innerHTML = '<span class="_bgWhite _typeWriter00" aria-hidden="true"></span>';
                    item0301words.forEach((word, index) => {
                      setTimeout(() => {
                        element0301.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0302words = ['デ', 'ジ', 'タ', 'ル', 'イ', 'ン', 'ボ', 'イ', 'ス', 'も'];
                    element0302.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0302words.forEach((word, index) => {
                      setTimeout(() => {
                        element0302.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 1000);
                  setTimeout(() => {
                    const item0303words = [
                      '<span class="_colorPrimary">一</span>',
                      '<span class="_colorPrimary">元</span>',
                      '<span class="_colorPrimary">管</span>',
                      '<span class="_colorPrimary _lastText">理</span>',
                    ];
                    element0303.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                    item0303words.forEach((word, index) => {
                      setTimeout(() => {
                        element0303.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                }
              });
            } else if (activeSlide.classList.contains('js-typeWriter03')) {
              item03Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriter03-01');
                const element02 = block.querySelector('.js-typeWriter03-02');
                const element03 = block.querySelector('.js-typeWriter03-03');
                element01.innerHTML = '';
                element02.innerHTML = '';
                element03.innerHTML = '';
              });
              item04Blocks?.forEach((block) => {
                const element0401 = block.querySelector('.js-typeWriter04-01');
                const element0402 = block.querySelector('.js-typeWriter04-02');
                setTimeout(() => {
                  const item0401words = ['イ', 'ン', 'ボ', 'イ', 'ス', '制', '度', '・'];
                  element0401.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                  item0401words.forEach((word, index) => {
                    setTimeout(() => {
                      element0401.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 0);
                setTimeout(() => {
                  const item0402words = [
                    '電',
                    '帳',
                    '法',
                    'へ',
                    'の',
                    '<span class="_colorPrimary">対</span>',
                    '<span class="_colorPrimary">応</span>',
                    '<span class="_colorPrimary">機</span>',
                    '<span class="_colorPrimary _lastText">能</span>',
                  ];
                  element0402.innerHTML = '<span class="_leadBlock _typeWriter02" aria-hidden="true"></span>';
                  item0402words.forEach((word, index) => {
                    setTimeout(() => {
                      element0402.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 2500);
              });
            }
          },
        },
      }),
    );
  });
  carousel();
};

const sliderEn = () => {
  const containerElements = document.querySelectorAll('.js-mvCopyEn');
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };
  containerElements.forEach((element) => {
    carouselInstance.push(
      new Carousel(element, {
        modules: [Autoplay, EffectFade],
        loop: false,
        slidesPerView: 'auto',
        speed: 0,
        followFinger: false,
        effect: 'fade',
        autoplay: {
          delay: 7500,
          disableOnInteraction: false,
        },
        on: {
          beforeInit() {
            const firstSlideBlock = element.querySelector('.js-typeWriterEn01');
            if (firstSlideBlock === null) return;
            const element01 = firstSlideBlock.querySelector('.js-typeWriterEn01-01');
            const element02 = firstSlideBlock.querySelector('.js-typeWriterEn01-02');
            setTimeout(() => {
              const item0101words = [
                'A',
                'd',
                'o',
                'p',
                't',
                'e',
                'd',
                ' ',
                'b',
                'y',
                ' ',
                'm',
                'a',
                'n',
                'y',
                ' ',
                'l',
                'a',
                'r',
                'g',
                'e',
              ];
              element01.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
              item0101words.forEach((word, index) => {
                setTimeout(() => {
                  element01.firstElementChild.innerHTML += word;
                }, 100 * index);
              });
            }, 500);
            setTimeout(() => {
              const item0102words = [
                '<span class="_colorPrimary">E</span>',
                '<span class="_colorPrimary">n</span>',
                '<span class="_colorPrimary">t</span>',
                '<span class="_colorPrimary">e</span>',
                '<span class="_colorPrimary">r</span>',
                '<span class="_colorPrimary">p</span>',
                '<span class="_colorPrimary">r</span>',
                '<span class="_colorPrimary">i</span>',
                '<span class="_colorPrimary">s</span>',
                '<span class="_colorPrimary">e</span>',
                '<span class="_colorPrimary _lastText">s</span>',
              ];
              element02.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
              item0102words.forEach((word, index) => {
                setTimeout(() => {
                  element02.firstElementChild.innerHTML += word;
                }, 100 * index);
              });
            }, 2800);
          },
          slideChange() {
            const activeSlide = element.querySelector('.swiper-slide-active');
            if (activeSlide === null) return;
            const item01Blocks = element.querySelectorAll('.js-typeWriterEn01');
            const item02Blocks = element.querySelectorAll('.js-typeWriterEn02');
            const item03Blocks = element.querySelectorAll('.js-typeWriterEn03');
            const item04Blocks = element.querySelectorAll('.js-typeWriterEn04');
            if (activeSlide.classList.contains('js-typeWriterEn04')) {
              item04Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriterEn04-01');
                const element02 = block.querySelector('.js-typeWriterEn04-02');
                element01.innerHTML = '';
                element02.innerHTML = '';
              });
              item01Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriterEn01-01');
                const element02 = block.querySelector('.js-typeWriterEn01-02');
                setTimeout(() => {
                  const item0101words = [
                    'A',
                    'd',
                    'o',
                    'p',
                    't',
                    'e',
                    'd',
                    ' ',
                    'b',
                    'y',
                    ' ',
                    'm',
                    'a',
                    'n',
                    'y',
                    ' ',
                    'l',
                    'a',
                    'r',
                    'g',
                    'e',
                  ];
                  element01.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                  item0101words.forEach((word, index) => {
                    setTimeout(() => {
                      element01.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 0);
                setTimeout(() => {
                  const item0102words = [
                    '<span class="_colorPrimary">E</span>',
                    '<span class="_colorPrimary">n</span>',
                    '<span class="_colorPrimary">t</span>',
                    '<span class="_colorPrimary">e</span>',
                    '<span class="_colorPrimary">r</span>',
                    '<span class="_colorPrimary">p</span>',
                    '<span class="_colorPrimary">r</span>',
                    '<span class="_colorPrimary">i</span>',
                    '<span class="_colorPrimary">s</span>',
                    '<span class="_colorPrimary">e</span>',
                    '<span class="_colorPrimary _lastText">s</span>',
                  ];
                  element02.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                  item0102words.forEach((word, index) => {
                    setTimeout(() => {
                      element02.firstElementChild.innerHTML += word;
                    }, 100 * index);
                  });
                }, 2800);
              });
            } else if (activeSlide.classList.contains('js-typeWriterEn01')) {
              item01Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriterEn01-01');
                const element02 = block.querySelector('.js-typeWriterEn01-02');
                element01.innerHTML = '';
                element02.innerHTML = '';
              });
              item02Blocks?.forEach((block) => {
                const element0201 = block.querySelector('.js-typeWriterEn02-01');
                const element0202 = block.querySelector('.js-typeWriterEn02-02');
                const element0203 = block.querySelector('.js-typeWriterEn02-03');
                if (matchMedia('md').matches) {
                  setTimeout(() => {
                    const item0201words = [
                      '<span class="_colorPrimary">N</span>',
                      '<span class="_colorPrimary">o</span>',
                      '<span class="_colorPrimary">.</span>',
                      '<span class="_colorPrimary _lastText">1</span>',
                      ' ',
                      's',
                      'h',
                      'a',
                      'r',
                      'e',
                      ' ',
                      'i',
                      'n',
                      ' ',
                      's',
                      'a',
                      'l',
                      'e',
                      's',
                      ' ',
                      'o',
                      'f',
                    ];
                    element0201.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0201words.forEach((word, index) => {
                      setTimeout(() => {
                        element0201.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0202words = [
                      'p',
                      'a',
                      'y',
                      'm',
                      'e',
                      'n',
                      't',
                      '-',
                      'r',
                      'e',
                      'l',
                      'a',
                      't',
                      'e',
                      'd',
                      ' ',
                      'd',
                      'o',
                      'c',
                      'u',
                      'm',
                      'e',
                      'n',
                      't',
                      ' ',
                      's',
                      'o',
                      'l',
                      'u',
                      't',
                      'i',
                      'o',
                      'n',
                      's',
                    ];
                    element0202.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0202words.forEach((word, index) => {
                      setTimeout(() => {
                        element0202.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                } else {
                  setTimeout(() => {
                    const item0201words = [
                      '<span class="_colorPrimary">N</span>',
                      '<span class="_colorPrimary">o</span>',
                      '<span class="_colorPrimary">.</span>',
                      '<span class="_colorPrimary _lastText">1</span>',
                      ' ',
                      's',
                      'h',
                      'a',
                      'r',
                      'e',
                      ' ',
                      'i',
                      'n',
                      ' ',
                      's',
                      'a',
                      'l',
                      'e',
                      's',
                      ' ',
                      'o',
                      'f',
                    ];
                    element0201.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0201words.forEach((word, index) => {
                      setTimeout(() => {
                        element0201.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0202words = ['p', 'a', 'y', 'm', 'e', 'n', 't', '-', 'r', 'e', 'l', 'a', 't', 'e', 'd'];
                    element0202.innerHTML = '<span class="_bgWhite _typeWriterEn02" aria-hidden="true"></span>';
                    item0202words.forEach((word, index) => {
                      setTimeout(() => {
                        element0202.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                  setTimeout(() => {
                    const item0203words = [
                      'd',
                      'o',
                      'c',
                      'u',
                      'm',
                      'e',
                      'n',
                      't',
                      ' ',
                      's',
                      'o',
                      'l',
                      'u',
                      't',
                      'i',
                      'o',
                      'n',
                      's',
                    ];
                    element0203.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0203words.forEach((word, index) => {
                      setTimeout(() => {
                        element0203.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 4500);
                }
              });
            } else if (activeSlide.classList.contains('js-typeWriterEn02')) {
              item02Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriterEn02-01');
                const element02 = block.querySelector('.js-typeWriterEn02-02');
                const element03 = block.querySelector('.js-typeWriterEn02-03');
                element01.innerHTML = '';
                element02.innerHTML = '';
                element03.innerHTML = '';
              });
              item03Blocks?.forEach((block) => {
                const element0301 = block.querySelector('.js-typeWriterEn03-01');
                const element0302 = block.querySelector('.js-typeWriterEn03-02');
                const element0303 = block.querySelector('.js-typeWriterEn03-03');
                if (matchMedia('md').matches) {
                  setTimeout(() => {
                    const item0301words = [
                      '<span class="_colorPrimary">C</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary">n</span>',
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">r</span>',
                      '<span class="_colorPrimary">a</span>',
                      '<span class="_colorPrimary">l</span>',
                      '<span class="_colorPrimary">i</span>',
                      '<span class="_colorPrimary">z</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary _lastText">d</span>',
                      ' ',
                      'm',
                      'a',
                      'n',
                      'a',
                      'g',
                      'e',
                      'm',
                      'e',
                      'n',
                      't',
                      ' ',
                      'o',
                      'f',
                    ];
                    element0301.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0301words.forEach((word, index) => {
                      setTimeout(() => {
                        element0301.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0302words = [
                      'p',
                      'a',
                      'p',
                      'e',
                      'r',
                      ',',
                      ' ',
                      'P',
                      'D',
                      'F',
                      ' ',
                      'a',
                      'n',
                      'd',
                      ' ',
                      'd',
                      'i',
                      'g',
                      'i',
                      't',
                      'a',
                      'l',
                      ' ',
                      'i',
                      'n',
                      'v',
                      'o',
                      'i',
                      'c',
                      'e',
                      's',
                    ];
                    element0302.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0302words.forEach((word, index) => {
                      setTimeout(() => {
                        element0302.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                } else {
                  setTimeout(() => {
                    const item0301words = [
                      '<span class="_colorPrimary">C</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary">n</span>',
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">r</span>',
                      '<span class="_colorPrimary">a</span>',
                      '<span class="_colorPrimary">l</span>',
                      '<span class="_colorPrimary">i</span>',
                      '<span class="_colorPrimary">z</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary _lastText">d</span>',
                      ' ',
                      'm',
                      'a',
                      'n',
                      'a',
                      'g',
                      'e',
                      'm',
                      'e',
                      'n',
                      't',
                      ' ',
                      'o',
                      'f',
                    ];
                    element0301.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0301words.forEach((word, index) => {
                      setTimeout(() => {
                        element0301.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0302words = ['p', 'a', 'p', 'e', 'r', ',', ' ', 'P', 'D', 'F'];
                    element0302.innerHTML = '<span class="_bgWhite _typeWriterEn02" aria-hidden="true"></span>';
                    item0302words.forEach((word, index) => {
                      setTimeout(() => {
                        element0302.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                  setTimeout(() => {
                    const item0303words = [
                      'a',
                      'n',
                      'd',
                      ' ',
                      'd',
                      'i',
                      'g',
                      'i',
                      't',
                      'a',
                      'l',
                      ' ',
                      'i',
                      'n',
                      'v',
                      'o',
                      'i',
                      'c',
                      'e',
                      's',
                    ];
                    element0303.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0303words.forEach((word, index) => {
                      setTimeout(() => {
                        element0303.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 4500);
                }
              });
            } else if (activeSlide.classList.contains('js-typeWriterEn03')) {
              item03Blocks?.forEach((block) => {
                const element01 = block.querySelector('.js-typeWriterEn03-01');
                const element02 = block.querySelector('.js-typeWriterEn03-02');
                const element03 = block.querySelector('.js-typeWriterEn03-03');
                element01.innerHTML = '';
                element02.innerHTML = '';
                element03.innerHTML = '';
              });
              item04Blocks?.forEach((block) => {
                const element0401 = block.querySelector('.js-typeWriterEn04-01');
                const element0402 = block.querySelector('.js-typeWriterEn04-02');
                if (matchMedia('md').matches) {
                  setTimeout(() => {
                    const item0401words = [
                      'F',
                      'u',
                      'n',
                      'c',
                      't',
                      'i',
                      'o',
                      'n',
                      's',
                      ' ',
                      'c',
                      'o',
                      'm',
                      'p',
                      'l',
                      'y',
                      'i',
                      'n',
                      'g',
                    ];
                    element0401.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0401words.forEach((word, index) => {
                      setTimeout(() => {
                        element0401.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0402words = [
                      'w',
                      'i',
                      't',
                      'h',
                      ' ',
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">h</span>',
                      '<span class="_colorPrimary">e</span>',
                      ' ',
                      '<span class="_colorPrimary">l</span>',
                      '<span class="_colorPrimary">a</span>',
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary">s</span>',
                      '<span class="_colorPrimary _lastText">t</span>',
                      ' ',
                      'J',
                      'a',
                      'p',
                      'a',
                      'n',
                      'e',
                      's',
                      'e',
                      ' ',
                      'l',
                      'a',
                      'w',
                      's',
                    ];
                    element0402.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0402words.forEach((word, index) => {
                      setTimeout(() => {
                        element0402.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                } else {
                  setTimeout(() => {
                    const item0401words = [
                      'F',
                      'u',
                      'n',
                      'c',
                      't',
                      'i',
                      'o',
                      'n',
                      's',
                      ' ',
                      'c',
                      'o',
                      'm',
                      'p',
                      'l',
                      'y',
                      'i',
                      'n',
                      'g',
                      ' ',
                      'w',
                      'i',
                      't',
                      'h',
                    ];
                    element0401.innerHTML = '<span class="_bgWhite _typeWriter01" aria-hidden="true"></span>';
                    item0401words.forEach((word, index) => {
                      setTimeout(() => {
                        element0401.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 0);
                  setTimeout(() => {
                    const item0402words = [
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">h</span>',
                      '<span class="_colorPrimary">e</span>',
                      ' ',
                      '<span class="_colorPrimary">l</span>',
                      '<span class="_colorPrimary">a</span>',
                      '<span class="_colorPrimary">t</span>',
                      '<span class="_colorPrimary">e</span>',
                      '<span class="_colorPrimary">s</span>',
                      '<span class="_colorPrimary _lastText">t</span>',
                      ' ',
                      'J',
                      'a',
                      'p',
                      'a',
                      'n',
                      'e',
                      's',
                      'e',
                      ' ',
                      'l',
                      'a',
                      'w',
                      's',
                    ];
                    element0402.innerHTML = '<span class="_bgWhite _typeWriter02" aria-hidden="true"></span>';
                    item0402words.forEach((word, index) => {
                      setTimeout(() => {
                        element0402.firstElementChild.innerHTML += word;
                      }, 100 * index);
                    });
                  }, 2500);
                }
              });
            }
          },
        },
      }),
    );
  });
  carousel();
};

const sliderCard = () => {
  const containerElements = document.querySelectorAll('.js-sliderCard');
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };
  containerElements.forEach((element) => {
    const slides = element.querySelectorAll('.swiper-slide');
    carouselInstance.push(
      new Carousel(element, {
        modules: [Autoplay, Pagination],
        loop: slides.length > 1,
        slidesPerView: 'auto',
        speed: 2000,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: element.querySelector('.swiper-pagination'),
          type: 'bullets',
        },
      }),
    );
  });
  carousel();
};

const sliderEvent = () => {
  const containerElements = document.querySelectorAll('.js-sliderEvent');
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };
  containerElements.forEach((element) => {
    const slides = element.querySelectorAll('.swiper-slide');
    carouselInstance.push(
      new Carousel(element, {
        modules: [Autoplay, Pagination],
        loop: slides.length > 1,
        slidesPerView: 'auto',
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: element.querySelector('.swiper-pagination'),
          type: 'bullets',
        },
      }),
    );
  });
  carousel();
};

export function slider() {
  sliderMV();
  sliderEn();
  sliderCard();
  sliderEvent();
}
